import React, { Component } from 'react';
import { Header, Container, Segment, List } from 'semantic-ui-react';

class Reasons extends Component {
  render() {
    const { tittel, medlemsfordeler } = this.props;
    return (
      <Container text>
        <Segment basic id="medlemsfordeler">
          <Header as="h1">
            <span dangerouslySetInnerHTML={{ __html: tittel }} />
          </Header>
          <List as="ol" size="large" className="medlemsfordeler">
            {medlemsfordeler.map((reason, index) => (
              <List.Item as="li" key={`reason-${index}`}>
                <List.Header>{reason[0]}</List.Header>
                <List.Description>{reason[1]}</List.Description>
              </List.Item>
            ))}
          </List>
        </Segment>
      </Container>
    );
  }
}

export default Reasons;



// WEBPACK FOOTER //
// ./src/LandingPage/Reasons.js